import "./style.css";
import visorLogo from "../../views/MapView/visor-logo.png";

/** Modal de bienvenida que se muestra al cargar el visor.
 * - onClose: cerrar y quedarse en la vista de Chile.
 * - onGeolocate: cerrar y centrar el mapa en la ubicación del usuario. */
export default function WelcomeModal({ onClose, onGeolocate }) {
  return (
    <div className="clbb-welcome-overlay">
      <div className="clbb-welcome" role="dialog" aria-modal="true" aria-label="Bienvenida">
        <div className="clbb-welcome-header">
          <img src={visorLogo} alt="Visor de Tráfico y Accidentes" className="clbb-welcome-logo" />
        </div>
        <div className="clbb-welcome-body">
          <p>
            El <strong>Visor de Tráfico y Accidentes</strong> de City Lab Biobío visualiza la
            congestión vehicular y las alertas de tránsito (accidentes, peligros, calles cerradas)
            de <strong>todo Chile</strong>, a partir de datos de Waze.
          </p>
          <p>
            La información presentada tiene carácter referencial y no reemplaza ni sustituye la
            información oficial entregada por las instituciones pertinentes.
          </p>
          <p className="clbb-welcome-note">
            El mapa inicia mostrando todo Chile. Los datos se cargan automáticamente según el área
            visible; elija una región o comuna, o use su ubicación para empezar.
          </p>
        </div>
        <div className="clbb-welcome-footer">
          <button type="button" className="clbb-welcome-btn secondary" onClick={onGeolocate}>
            <span className="material-icons">my_location</span>
            Geolocalizarme
          </button>
          <button type="button" className="clbb-welcome-btn primary" onClick={onClose}>
            Entendido, comenzar
          </button>
        </div>
      </div>
    </div>
  );
}
